import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Button, Table, Pagination, Row, Col, Space } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined, DeleteOutlined, FormOutlined } from '@ant-design/icons'
import { Loading, Page, Panel, Total } from '../../../../../../../components'
import { BreadcrumbSystem as Breadcrumb, SysPermission } from '../../../../../../../constants'
import { sysAdminRoleService, orgAdminRoleService } from '../../../../../../../services'
import { auth, validator } from '../../../../../../../util'
import { SysStore } from '../../../../../../../stores'

import 'antd/dist/antd.css'
import './styles.css'

const pageSize = 20

const columns = (orgId) => ([
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 8
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 11
  },
  {
    width: 2,
    title: 'Active',
    dataIndex: 'active',
    key: 'active',
    render: (active) => active === true
      ? <CheckCircleOutlined style={{color: '#4fbc85', fontSize: '14pt'}} />
      : <CloseCircleOutlined style={{color: '#ccc', fontSize: '14pt'}} />
  },
  {
    width: 3,
    render: (item) => <Space size='middle'>
      { hasAccess(SysPermission.ORGANISATIONS.PORTAL_ROLES.UPDATE)
        ? <Link to={`/organisations/listing/${orgId}/roles/${item.id}`} key={`rolekey${item.id}`}>
          <FormOutlined />
        </Link>
        : null }
    </Space>
  },
])

const hasAccess = (permission) => {
  return auth.hasAccess(permission)
}

function OrgAdminRoleList (props) {
  const orgId = props.orgId
  const [isLoading, setIsLoading] = useState(false)
  const [list, setList] = useState([])
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState({ active: true })
  const [sort, setSort] = useState({})

  useEffect(() => {
    fetchList({ currentPage: 1 })
  }, [])

  async function fetchList ({ currentPage = page }) {
    if (!hasAccess(SysPermission.ORGANISATIONS.PORTAL_ROLES.LIST)) return

    setIsLoading(true)
    filter.org_id = orgId

    const r = await orgAdminRoleService.listByPage(currentPage, pageSize, filter, sort)
    if (r && r.list) {
      setIsLoading(false)
      setList(r.list)
      setPage(currentPage)
      setTotal(r.total)
    }
  }

  return (
    <div>
      {/* <Page.Breadcrumb item={breadcrumb} />

      <Page.Header title='User Roles'>
        <Link to='/systems/roles/add'>
          <Button shape='round' type='primary'>Add User Role</Button>
        </Link>
      </Page.Header> */}
      <Page.Header title='User Roles'>
        { hasAccess(SysPermission.ORGANISATIONS.PORTAL_ROLES.CREATE)
          ? <Link to={`/organisations/listing/${orgId}/roles/add`}>
            <Button shape='round' type='primary'>Add User Role</Button>
          </Link>
          : null }

      </Page.Header>

      <Page.Content>
        <Table
          loading={isLoading}
          columns={columns(orgId)}
          dataSource={list}
          size='small'
          rowKey={(itm) => (`rolels${itm.id}`)}
          pagination={{
            hideOnSinglePage: true,
            pageSize,
            total,
            onChange: (e) => fetchList({currentPage: e})
          }}
        />
        <Total total={total} title={'role'} />
      </Page.Content>
    </div>
  )
}

export default OrgAdminRoleList
